import { render, staticRenderFns } from "./FissionStatisticsPane.vue?vue&type=template&id=236fee52&scoped=true"
import script from "./FissionStatisticsPane.vue?vue&type=script&lang=js"
export * from "./FissionStatisticsPane.vue?vue&type=script&lang=js"
import style0 from "./FissionStatisticsPane.vue?vue&type=style&index=0&id=236fee52&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236fee52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('236fee52')) {
      api.createRecord('236fee52', component.options)
    } else {
      api.reload('236fee52', component.options)
    }
    module.hot.accept("./FissionStatisticsPane.vue?vue&type=template&id=236fee52&scoped=true", function () {
      api.rerender('236fee52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/fission/components/FissionStatisticsPane.vue"
export default component.exports